export enum IntegrationAuthTypeEnum {
  OAUTH = 'OAUTH',
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  GITHUB_APP = 'GITHUB_APP',
}
